var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrain = function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.232 28c0 .94-.727 1.702-1.622 1.702-.897 0-1.623-.762-1.623-1.701 0-.94.726-1.7 1.623-1.7.895 0 1.622.76 1.622 1.7zm-3.245-4h12.028v-9.098H17.987zm8.08-12.698c.344 0 .622.29.622.65a.635.635 0 0 1-.621.648h-4.392a.634.634 0 0 1-.62-.648c0-.36.279-.65.62-.65h4.392zm.701 16.7c0-.94.728-1.7 1.625-1.7.894 0 1.622.76 1.622 1.7 0 .938-.728 1.7-1.622 1.7-.897 0-1.625-.762-1.625-1.7M30.586 32c1.213 0 2.197-1.03 2.197-2.298v-18.4c0-1.271-.984-2.302-2.197-2.302h-13.17c-1.216 0-2.198 1.03-2.198 2.302v18.4c0 1.269.982 2.298 2.197 2.298zm-20.494 7h4.445l5.987-5.698H16.69zm21.446-5.698h-3.7l5.778 5.5h4.292z"
  }))));
};
export default SvgTrain;